interface HealthValue {
  value: number | string
  created_at: string
}

export function calculateStepsMean(
  values: HealthValue[],
  period: string
): number {
  const numericValues = values
    .map(item => Number(item.value))
    .filter(val => !Number.isNaN(val))

  if (!numericValues.length) return 0

  let mean: number

  switch (period) {
    case 'day':
      mean = numericValues.reduce((a, b) => a + b, 0) / 24
      break

    case 'week':
      mean = numericValues.reduce((a, b) => a + b, 0) / 7

      break

    case 'month':
      mean = numericValues.reduce((a, b) => a + b, 0) / 30
      break

    case 'year':
      mean = numericValues.reduce((a, b) => a + b, 0) / 12

      break

    default: {
      const avg =
        numericValues.reduce((sum, val) => sum + val, 0) / numericValues.length
      return avg
    }
  }

  return Math.round(mean)
}
